import { ITag } from '@raas/shared/src/types/tag';

export enum BodyChanged {
  DELETED = 'deleted',
  CHANGED = 'changed',
  NEW = 'new',
  NOT_CHANGED = 'not_changed',
  MOVED = 'moved',
}

export type BodyChangeCounts = {
  [key in BodyChanged]: number;
};

export type IReadDocumentElement = {
  id: string;
  entityId: string;
  parentEntityId: string;
  officialParagraphNumber: string;
  title: string;
  mainBody: string;
  validFrom?: Date;
  validTo?: Date;
  order: number;
  legalProvisionEntityId: string;
  tags?: ITag[];
  versionId: string;
  releaseId: string;
  translations?: IDocumentElementTranslation[];
  officialParagraphNumberHtml?: string;
  titleHtml?: string;
  mainBodyHtml?: string;
};

export type IWriteDocumentElement = {
  id: string;
  parentEntityId: string;
  officialParagraphNumber: string;
  title: string;
  mainBody: string;
  validFrom?: Date;
  validTo?: Date;
  order: number;
  legalProvisionEntityId: string;
  tagIds: string[];
  officialParagraphNumberHtml?: string;
  titleHtml?: string;
  mainBodyHtml?: string;
};

export type IMoveDocumentElement = {
  parentEntityId: string;
  order: number;
};

export type IDocumentElementDetails = IReadDocumentElement & {
  children: IDocumentElementDetails[];
  parentTitle?: string;
  parentOfficialParagraphNumber?: string;
  // Used to distinguish between new, changed and unchanged document elements in the UI
  editorState?: BodyChanged;
};

export type IMoveIntoDocumentElements = {
  ids: string[];
};

export type ITableOfContentsElement = {
  id: string;
  entityId: string;
  label: string;
  bodyChanged?: BodyChanged;
  childBodyChanged?: BodyChangeCounts;

  changeStatus?: BodyChanged;
  childChangeStatus?: BodyChangeCounts;
  isDraft: boolean;
};

export type ITableOfContentsElementList = ITableOfContentsElement & {
  children: ITableOfContentsElementList[];
};

export type IDocumentElementDetailsChanges = IReadDocumentElement & {
  children: IDocumentElementDetailsChanges[];
  parentTitle?: string;
  parentOfficialParagraphNumber?: string;
  editorState?: BodyChanged;
  bodyChanged?: BodyChanged;
  childBodyChanged?: BodyChangeCounts;
};

export type IDocumentElementTranslation = {
  translationId: string;
  documentElementId: string;
  legalProvisionTranslationId: string;
  officialParagraphNumber: string;
  title: string;
  mainBody: string;
  officialParagraphNumberHtml?: string;
  titleHtml?: string;
  mainBodyHtml?: string;
};

export type ComparePropertiesDocumentElement = {
  documentElementId?: string;
  officialParagraphNumber?: string;
  title?: string;
  mainBody?: string;
};

export type IDocumentElementDelta = {
  id: string;
  entityId: string;
  base?: ComparePropertiesDocumentElement;
  compare?: ComparePropertiesDocumentElement;
  parentEntityId: string;
  validFrom?: Date;
  validTo?: Date;
  order: number;
  legalProvisionEntityId: string;
  tags?: ITag[];
  versionId: string;
  releaseId: string;
  children: IDocumentElementDelta[];
  translations?: IDocumentElementTranslation[];

  changeStatus: BodyChanged;
  childChangeStatus?: BodyChangeCounts;
  parentTitle?: string;
  parentOfficialParagraphNumber?: string;
  totalScore?: number;
};
